var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("node-view-wrapper", [
    _c("div", {
      staticClass: "custom-signature",
      domProps: { innerHTML: _vm._s(_vm.signature) }
    })
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }